// extracted by mini-css-extract-plugin
export var bodySections = "_79-8";
export var gray = "_79-7";
export var green = "_79-4";
export var iconContainer = "_79-9";
export var iconWidgetContainer = "_79-1";
export var phoneIcon = "_79-2";
export var red = "_79-5";
export var statusDot = "_79-3";
export var widgetContainer = "_79-0";
export var yellow = "_79-6";